/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { OAuthTokenRequest } from '../models/OAuthTokenRequest';
import type { OAuthTypeEnum } from '../models/OAuthTypeEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Verify Token
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public static verifyTokenOauth2Post(
        requestBody: OAuthTokenRequest,
    ): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth2/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Token
     * @param oauthType
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public static deleteTokenOauth2Delete(
        oauthType: OAuthTypeEnum,
    ): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/oauth2/',
            query: {
                'oauth_type': oauthType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
